import {useState} from 'react';
import {publishEvent, useEvent} from "./useEvent";

export function useLocalStorage(key: string, publish?: boolean): [string | null, (value: string|null) => void] {
    const [storedValue, setStoredValue] = useState<string|null>(() => window.localStorage.getItem(key))

    useEvent<LocalStorageEvent<string>>('localStorage', (data) => {
        if (data && data.key === key) {
            setStoredValue(data.value)
        }
    })

    const set = (value: string|null) => {
        window.localStorage.setItem(key, value!);
        if (publish === false) {
            setStoredValue(value)
        } else {
            publishEvent<LocalStorageEvent<string>>('localStorage', {key: key, value: value})
        }
    }

    return [storedValue, set];
}

export function useLocalStorageT<T>(key: string, publish?: boolean): [T | null, (value: T | null) => void]  {
    const [storedValue, setStoredValue] = useState<T|null>(() => {
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        } catch (error) {
            return null;
        }
    })

    useEvent<LocalStorageEvent<T>>('localStorage', (data) => {
        if (data && data.key === key) {
            setStoredValue(data.value)
        }
    })

    const set = (value: T|null) => {
        window.localStorage.setItem(key, JSON.stringify(value));
        if (publish === false) {
            setStoredValue(value)
        } else {
            publishEvent<LocalStorageEvent<T>>('localStorage', {key: key, value: value})
        }
    }

    return [storedValue, set];
}

export interface LocalStorageEvent<T>{
    key: string
    value: T|null
}